import toast from 'react-hot-toast'

import { useMutation, useQueryClient } from '@fv/client-core'

import {
  bucketCountKeys,
  opportunityQueryKeys,
  quoteRequestKeys,
} from '@/queryKeys'
import { carrierFetch } from '@/utils/carrierFetch'

interface ArchiveOppArgs {
  carrierId: string
}
interface Response {
  shipmentArchivedCount: number
  loadArchivedCount: number
}
async function archiveCanceledOpportunities(body: ArchiveOppArgs) {
  return await carrierFetch<Response>(`/opportunities/canceled`, {
    method: 'DELETE',
    body,
  })
}

export function useArchiveCanceledOpportunities() {
  const queryClient = useQueryClient()

  return useMutation(archiveCanceledOpportunities, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: opportunityQueryKeys.all })
      queryClient.invalidateQueries({ queryKey: quoteRequestKeys.all })
      toast.success('Removed canceled shipments successfully.')
      queryClient.invalidateQueries({ queryKey: bucketCountKeys.all })
    },
  })
}
